import { useEffect } from "react";

import { mockData } from "Payments/PaymentPage/mockData";

import { usePaymentForm } from "./PaymentFormContext";

export function useSetInitialFormStages() {
  const { dispatch } = usePaymentForm();

  return useEffect(() => {
    let pageData = window.data?.paymentPageData;

    if (mockData.shouldMock) {
      pageData = mockData.paymentPageData;
    }

    const isFullyLoggedIn = pageData.user?.loginLevel === "full";
    const hasPaymentMethod = pageData.paymentMethods?.length > 0;
    const isHappyPath = isFullyLoggedIn && hasPaymentMethod;

    const amountInitial = "expanded";
    const authInitial = isFullyLoggedIn ? "isFullyLoggedIn" : "untouched";
    const paymentInfoInitial = isHappyPath ? "methodSelected" : "untouched";

    dispatch({
      type: "setFormStages",
      payload: {
        amount: amountInitial,
        auth: authInitial,
        paymentInfo: paymentInfoInitial,
      },
    });
  }, [dispatch]);
}
